import { Box, Divider, Link, Typography } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

function Footer() {
  const ref = useRef(null);
  const divider2Ref = useRef(null);
  const { animationStarted } = useAnimation();
  const isInView = useInView(ref, { once: true, margin: "0px" });
  const divider2InView = useInView(divider2Ref, { once: true, margin: "0px" });

  return (
    <Box
      component={motion.footer}
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={
        isInView && animationStarted
          ? { opacity: 1, y: 0 }
          : { opacity: 0, y: 30 }
      }
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      sx={{
        textAlign: "center",
        py: 2,
        mt: 2,
      }}
    >
      <Divider
        component={motion.hr}
        ref={divider2Ref}
        initial={{ opacity: 0, scaleX: 0 }}
        animate={
          divider2InView && animationStarted
            ? { opacity: 0.3, scaleX: 1 }
            : { opacity: 0, scaleX: 0 }
        }
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        sx={{
          my: 2,
          mx: { xs: 4, sm: 6, md: 8 },
          borderColor: "#8b7355",
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "center",
          justifyContent: { xs: "center", lg: "space-between" },
          gap: { xs: 0, lg: 2 },
          px: { lg: 9 },
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "0.9rem", sm: "0.95rem" },
            fontWeight: 400,
            color: "#1a3a52",
            letterSpacing: "0.3px",
            mb: { xs: 0.5, lg: 0 },
          }}
        >
          Tiago Neves do Vale
        </Typography>
        <Box
          component="a"
          href="tel:+351910060107"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            textDecoration: "none",
            mb: { xs: 0.7, lg: 0 },
            "&:hover .phone-text": {
              color: "#1a3a52",
              textDecoration: "underline",
            },
          }}
        >
          <PhoneIcon sx={{ fontSize: "1rem", color: "#1a3a52" }} />
          <Typography
            className="phone-text"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.8rem", sm: "0.9rem", lg: "0.9rem" },
              fontWeight: 300,
              color: "#2d4e66",
              letterSpacing: "0px",
            }}
          >
            +351 910 060 107
          </Typography>
        </Box>
        <Box
          component="a"
          href="mailto:tiago.vale.dev@gmail.com"
          target="_blank"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            textDecoration: "none",
            mb: { xs: 0.4, lg: 0 },
            "&:hover .email-text": {
              color: "#1a3a52",
              textDecoration: "underline",
            },
          }}
        >
          <EmailIcon sx={{ fontSize: "1rem", color: "#1a3a52" }} />
          <Typography
            className="email-text"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.85rem", sm: "0.9rem" },
              fontWeight: 300,
              color: "#2d4e66",
              letterSpacing: "0.3px",
            }}
          >
            tiago.vale.dev@gmail.com
          </Typography>
        </Box>
        <Box
          component="a"
          href="https://www.linkedin.com/in/tiagonevesdovale"
          target="_blank"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            textDecoration: "none",
            mb: { xs: 0.8, lg: 0 },
            "&:hover .linkedin-text": {
              color: "#1a3a52",
              textDecoration: "underline",
            },
          }}
        >
          <LinkedInIcon sx={{ fontSize: "1rem", color: "#1a3a52" }} />
          <Typography
            className="linkedin-text"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "0.85rem", sm: "0.9rem" },
              fontWeight: 300,
              color: "#2d4e66",
              letterSpacing: "0.3px",
              mt: { xs: 0.4, lg: 0 },
            }}
          >
            linkedin.com/in/tiagonevesdovale
          </Typography>
        </Box>
        <Typography
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "0.75rem", sm: "0.8rem" },
            fontWeight: 500,
            color: "#1a3a52",
            letterSpacing: "0.5px",
            opacity: 1,
          }}
        >
          &copy; PIXELHARVEST - SOCIEDADE UNIPESSOAL LDA
        </Typography>
      </Box>
    </Box>
  );
}

export default Footer;
